import { types, getEnv, flow } from 'mobx-state-tree';

import { MobxEnvironment } from '../mobx-environment';
import { RequestStatusModel, RequestStatus } from '../../libs/helpers';
import { TranslationsResult } from '../../models';

export const ConfigStoreModel = types
  .model({
    status: RequestStatusModel,
    translations: types.frozen(),
  })
  .views(self => ({
    get environment() {
      return getEnv(self) as MobxEnvironment;
    },
  }))
  .actions(self => ({
    setStatus(value: RequestStatus) {
      self.status = value;
    },
  }))
  .actions(self => ({
    getTranslations: flow(function*(langCode: string) {
      try {
        const response: TranslationsResult = yield self.environment.configApi.getTranslations(
          langCode,
        );
        if (response.kind === 'ok') {
          self.translations = response.data;
          return response.data;
        } else {
          throw new Error(response.kind);
        }
      } catch (error) {
        throw new Error(error.message || error);
      }
    }),
  }));

type ConfigStoreType = typeof ConfigStoreModel.Type;
export interface ConfigStore extends ConfigStoreType {}
type ConfigStoreSnapshotType = typeof ConfigStoreModel.SnapshotType;
export interface ConfigStoreSnapshot extends ConfigStoreSnapshotType {}
